import ApiLpc from '@services/http/ApiLpc';
import { axiosClient, getUrl } from '@services/http/Http';

// TODO update updateAccount
const updateAccount = (body, ctx?: string) => axiosClient(ctx).put(ApiLpc.AUTH.UPDATE_ACCOUNT, JSON.stringify(body));

const updateProfilePicture = (orderId, body, ctx?: string) =>
    axiosClient(ctx).put(getUrl(ApiLpc.AUTH.UPDATE_PROFILE_PICTURE, orderId), JSON.stringify(body));

const getAccountInformations = (ctx?: string) =>
    axiosClient(ctx)
        .get(ApiLpc.AUTH.USER_CONTACT_INFORMATIONS)
        .then((response) => {
            return response.data;
        });

const subscribeToNewsLetter = (body, ctx?: string) =>
    axiosClient(ctx).post(ApiLpc.AUTH.SUBSCRIBE_ACCOUNT, JSON.stringify(body));

const validatePPE = (body, ctx?: string) => {
    return axiosClient(ctx).post(ApiLpc.USER_FLOW_BLOCK.VALIDATE_PPE, JSON.stringify(body), {
        responseType: 'blob',
    });
};

const checkPPEDocument = (ctx?: string) =>
    axiosClient(ctx)
        .get(getUrl(ApiLpc.USER_FLOW_BLOCK.CHECK_PPE_DOCUMENT))
        .then((res) => {
            return res.data;
        });

const accountService = {
    updateAccount,
    getAccountInformations,
    updateProfilePicture,
    subscribeToNewsLetter,
    validatePPE,
    checkPPEDocument,
};

export default accountService;
